// extracted by mini-css-extract-plugin
export default {"userDetails":"PersonalInfo_userDetails__4c8rc","form-group":"PersonalInfo_form-group__Lgoqe","weekoff":"PersonalInfo_weekoff__bUL-3","editbutton":"PersonalInfo_editbutton__6xKNh"};